import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, frame: { type: String, default: "modal" } }

  open(event) {
    event.preventDefault()

    const frame = document.getElementById(this.frameValue)
    frame.src = this.urlValue
  }
}
